module.exports = __webpack_public_path__ + "static/productionI-b178da4be6ae25965d1563ab18712001.svg";